import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { EMPTY_ARRAY, EMPTY_STRING } from '@e-socna/empty';
import type { RepresentativeTypeId, UserRoleId } from '@e-socna/data-layer';

import type { ThirdPartiesCmp_Person } from '../../../../components/ThirdParties/fragments/person.fragment';
import type { ActorCardCmp_OrganizationMembership } from '../../../../components/Actors/Card/fragments/organization-membership.fragment';

import { useReferencesContext } from '../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { UserRolesFormControl } from '../../../UserRoles';
import { RepresentativeTypesFormControl } from '../../../RepresentativeTypes';

import { useIsBaseRoleGivenToMembers } from '../../contexts/base-role-flags.context';

interface Props {
  readonly index: number;
  readonly isInternal: boolean;
  readonly membership: ActorCardCmp_OrganizationMembership | undefined;
  readonly person: ThirdPartiesCmp_Person;
}

export const RepresentativeDetails = ({
  index,
  isInternal,
  membership,
  person,
}: Readonly<Props>) => {
  const indexAsString = index.toFixed();
  const { userRolesCodeMap } = useReferencesContext();
  const isBaseRoleGiven = useIsBaseRoleGivenToMembers(isInternal);

  return (
    <Paper key={person._id} sx={{ width: '100%', p: 2 }}>
      <Typography sx={{ mb: 4 }} variant="h6">
        {`${person.firstName ? `${person.firstName} ` : EMPTY_STRING}${person.lastName}`}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={12} sx={{ pt: 1, pb: 1 }}>
          <UserRolesFormControl
            fallbackRoleIds={
              membership?.contextualRoleIds as
                readonly UserRoleId[] | null | undefined
            }
            lockedRoleIds={
              isBaseRoleGiven ? [userRolesCodeMap.Base._id] : EMPTY_ARRAY
            }
            name={`representatives[${indexAsString}].contextualRoleIds`}
            required={false}
            scope="contextual"
          />
        </Grid>
        <Grid size={12} sx={{ pt: 1, pb: 1 }}>
          <RepresentativeTypesFormControl
            fallbackTypeIds={
              membership?.representativeTypeIds as
                readonly RepresentativeTypeId[] | null | undefined
            }
            isInternal={isInternal}
            name={`representatives[${indexAsString}].typeIds`}
            required={false}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
